import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  ICreateCourseMaster,
  IUpdateCourseMaster,
} from '../interface/course-master.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CourseMasterHttpService {
  private BASE_URL = environment.apiBaseUrl;
  constructor(private readonly httpClient: HttpClient) {}

  getDropdownListByCode<T>(code: string): Observable<T[]> {
    return this.httpClient
      .get<{ resultList: T[] }>(`${this.BASE_URL}api/GetCodes/${code}`)
      .pipe(map((response) => response.resultList));
  }

  createCourseMaster<T>(courseMaster: ICreateCourseMaster) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/InsertOrUpdateCourseMaster`,
      courseMaster
    );
  }

  updateCourseMaster<T>(courseMaster: IUpdateCourseMaster) {
    return this.httpClient.post<T>(
      `${this.BASE_URL}api/InsertOrUpdateCourseMaster`,
      courseMaster
    );
  }

  getCourses<T>(
    loggedInUserId: string,
    courseMasterID: string,
    courseId: string,
    screenName: string,
    studentId: string
  ) {
    return this.httpClient.get<T>(
      `${this.BASE_URL}api/GetCourse?LoggedInUserId=${loggedInUserId}&CourseMasterID=${courseMasterID}&CourseID=&ScreenName=${screenName}&StudentID=`
    );
  }

  getCourseMasterById<T>(
    loggedInUserId: string,
    examAgencyId: string,
    courseMasterId: string
  ) {
    return this.httpClient.get<T>(
      `${this.BASE_URL}api/GetCourseMaster?LoggedInUserId=${loggedInUserId}&ExamAgencyId=${examAgencyId}&CourseMasterID=${courseMasterId}`
    );
  }
}
